
export function CredibilitySection() {
  return (
    <section id="credibilidade" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto mb-16 animate-fade-in">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gradient-to-r from-blue-800 to-blue-900 rounded-2xl p-8 text-center text-white shadow-lg">
              <h3 className="text-2xl font-bold mb-3">Laudo Aceito pela SABESP</h3>
              <p className="text-white/90">Laudo técnico oficialmente aceito pela SABESP para abatimento em conta de água.</p>
            </div>
            <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-2xl p-8 text-center text-white shadow-lg">
              <h3 className="text-2xl font-bold mb-3">Garantia de 1 Ano</h3>
              <p className="text-white/90">Todos os nossos serviços possuem garantia de 1 ano para sua total tranquilidade.</p>
            </div>
          </div>
        </div>
        
        <div className="max-w-6xl mx-auto mb-20 animate-fade-in-up">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white/80 backdrop-blur rounded-2xl p-8 shadow-lg border border-slate-200">
              <div className="w-14 h-14 rounded-full bg-slate-100 text-slate-700 flex items-center justify-center mx-auto mb-5">
                <i className="ri-award-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 text-center mb-3">Mais de 20 anos de experiência</h3>
              <p className="text-slate-600 text-center">
                Duas décadas entregando soluções premium em detecção e reparo de vazamentos com precisão e confiança.
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-emerald-500 via-emerald-400 to-emerald-500 rounded-2xl p-8 shadow-lg text-white relative overflow-hidden">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.25),transparent_55%)]"></div>
              <div className="relative z-10 flex flex-col items-center text-center gap-4">
                <div className="h-20 w-20 rounded-full bg-white flex items-center justify-center shadow-lg ring-4 ring-white/40">
                  <img 
                    src="https://mnnotgqwwzenmjfkzzmy.supabase.co/storage/v1/object/public/produtos/reclame-aqui-logo.png" 
                    alt="Reclame AQUI" 
                    className="h-12 w-auto"
                  />
                </div>
                <h3 className="text-xl font-semibold">Zero reclamações no Reclame AQUI</h3>
                <p className="text-white/90">
                  Transparência total e atendimento humanizado garantem nossa reputação impecável em todo o Brasil.
                </p>
              </div>
            </div>
            
            <div className="bg-white/80 backdrop-blur rounded-2xl p-8 shadow-lg border border-slate-200">
              <div className="w-14 h-14 rounded-full bg-blue-100 text-blue-800 flex items-center justify-center mx-auto mb-5">
                <i className="ri-star-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 text-center mb-3">O melhor trabalho de São Paulo</h3>
              <p className="text-slate-600 text-center">
                Referência em qualidade, tecnologia e atendimento premium para residências, comércios e indústrias.
              </p>
            </div>
          </div>
        </div>
        
        <div className="max-w-4xl mx-auto animate-fade-in">
          <div className="bg-white rounded-lg p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center">Dados Institucionais</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <div>
                  <p className="font-semibold text-slate-900 mb-1">CNPJ</p>
                  <p className="text-slate-600">07.531.351/0001-78</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div>
                  <p className="font-semibold text-slate-900 mb-1">Endereço</p>
                  <p className="text-slate-600">
                    Av. Diederichsen 918 – Sala 15<br />
                    Jabaquara – São Paulo – SP<br />
                    CEP 04310-000
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div>
                  <p className="font-semibold text-slate-900 mb-1">WhatsApp</p>
                  <a href="https://wa.me/5511948948561" className="text-blue-800 hover:underline">
                    (11) 94894-8561
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div>
                  <p className="font-semibold text-slate-900 mb-1">E-mail</p>
                  <a href="mailto:cacavazamentosmaster@gmail.com" className="text-blue-800 hover:underline">
                    cacavazamentosmaster@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
